import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-50 mt-16">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-play-circle-fill text-xl"></i>
            </span>
            <span className="font-heading font-bold text-lg">动漫在线观看</span>
          </div>
          <p className="text-sm text-primary-100 leading-relaxed">
            聚合最新与经典动漫视频资源，多分类浏览、多维筛选，让动画爱好者轻松找到心仪作品。
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-3 text-background-50">快速导航</h4>
          <ul className="space-y-2 text-sm text-primary-100">
            <li>
              <Link to="/" className="hover:text-accent-400 cursor-pointer">首页</Link>
            </li>
            <li>
              <Link to="/search" className="hover:text-accent-400 cursor-pointer">搜索动漫</Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-accent-400 cursor-pointer">关于我们</Link>
            </li>
            <li>
              <Link to="/category/少年" className="hover:text-accent-400 cursor-pointer">全部分类</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-3 text-background-50">热门分类</h4>
          <ul className="space-y-2 text-sm text-primary-100">
            {categories.slice(0, 5).map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/category/${encodeURIComponent(category.slug)}`}
                  className="hover:text-accent-400 cursor-pointer"
                >
                  {category.name}动漫
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-3 text-background-50">联系我们</h4>
          <ul className="space-y-2 text-sm text-primary-100">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <a href="mailto:support@anime-demo.example.com" className="hover:text-accent-400 cursor-pointer">
                support@anime-demo.example.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              7×24 小时在线服务
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-shield-check-line"></i>
              正版倡导 · 学习交流
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200">
          <p>© {year} 动漫在线观看 · 本站为演示站点，所有内容均为虚构示例</p>
          <p className="text-center sm:text-right">
            本站不提供真实视频播放与下载服务，仅供界面演示与学习交流
          </p>
        </div>
      </div>
    </footer>
  );
}